/**
 * Password policy for every form that sets a password (My Account, user
 * create, admin reset). Same rule as the backend's `validate_password_strength`
 * (`backend/src/modules/users/model.rs`), so a password this accepts is never
 * refused by the server:
 * - at least 12 characters, counted per Unicode code point (an emoji is one
 *   character, as in Rust's `chars()`), not per UTF-16 unit like `.length`;
 * - at least one letter A-Z / a-z;
 * - at least one digit 0-9.
 * Any other character (kana, symbols, emoji) is allowed.
 */
export const PASSWORD_MIN_LENGTH = 12;

export const meetsPasswordPolicy = (password: string): boolean =>
  Array.from(password).length >= PASSWORD_MIN_LENGTH &&
  /[A-Za-z]/.test(password) &&
  /[0-9]/.test(password);
